import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });

$w.onReady(function () {
	//TODO: write your page related code here...

});

export async function startNow_click(event) {
	await fireEvent('start now')
}

async function fireEvent(button) {
	const biEventObject = {
		evid: 703,
		button_name: button,
		is_valid: true,
		topic: 'wix partners site',
		url: wixLocation.url
	};
	await biLogger.log(biEventObject);
}

export async function bookAdemoHeader_click(event) {
	await fireEvent('book a demo')
}

export async function bookAdemoProjectsFlow_click(event) {
	await fireEvent('book a demo')
}

export async function bookAdemoComments_click(event) {
	await fireEvent('book a demo')
}

export async function bookAdemoProjects_click(event) {
	await fireEvent('book a demo')
}

export async function startNowProjectsFlow_click(event) {
	await fireEvent('start now') 
}

export async function startNowComments_click(event) {
	await fireEvent('start now') 
}